// extracted by mini-css-extract-plugin
export default {"dropDots":"EmployeeModal_dropDots__AkUbp"};